import React, { Component } from 'react'
import { ShippingParcel } from 'stylewhere/api'
import { OperationStart } from 'stylewhere/components'
import { SimpleParcelListExtensions } from 'stylewhere/extensions'
import { Routes } from 'stylewhere/pages'
import {
  FormSchema,
  FormSchemaData,
  FormSchemaRouteProps,
  getDataFromSchema,
  Router,
  SimpleParcelListOperationConfig,
} from 'stylewhere/shared'
import { showToast } from 'stylewhere/shared/utils'

export default class SimpleParcelListStart extends Component<FormSchemaRouteProps<{ opCode: string }>> {
  submitPath: Routes = '/simple-parcel-list/:opCode/reading'

  /** La lista di parcel dipende dalle implementazioni e verrà caricata qui */
  async getParcels(formData: FormSchemaData, operation: SimpleParcelListOperationConfig, schema: FormSchema) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const formSchemaData = getDataFromSchema(formData, schema)
    const parcels: ShippingParcel[] = []
    return parcels
  }

  async onSubmit(formData: FormSchemaData, operation: any, schema: FormSchema) {
    try {
      const parcels = await this.getParcels(formData, operation, schema)
      Router.navigate(this.submitPath, { opCode: operation.code }, { state: { formData, parcels } })
    } catch (err) {
      showToast({ status: 'error', title: 'Start Parcel Error', description: err?.message ?? 'Generic error' })
    }
  }

  render() {
    return (
      <OperationStart
        submitPath={this.submitPath}
        extensions={SimpleParcelListExtensions}
        onSubmit={(...args) => this.onSubmit(...args)}
      />
    )
  }
}
